<script lang="ts">
    import type { HTMLImgAttributes } from "svelte/elements";
    import icon from "../../../assets/icon-192x192.png";
    import { cn } from "../../utils.js";

    const props: HTMLImgAttributes = $props();
</script>

<enhanced:img src={icon} alt="turian logo" {...props} class={cn(props.class, "max-w-24")} />
